// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GZcs","field":"styles_field__2k2sS","fieldCol":"styles_fieldCol__2acwI","diffCol":"styles_diffCol__2P_M1","diff":"styles_diff__3H9MP"};